import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Steps from '../../components/Steps';
import ServiceAddress from '../../components/Steps/ServiceAddress';
import CustomerDetails from '../../components/Steps/CustomerDetails';
import CreateProfile from '../../components/Steps/CreateProfile';
import ProjectSpecifics from '../../components/Steps/ProjectSpecifics';
import Schedule from '../../components/Steps/Schedule';
import SubmitRequest from '../../components/Steps/SubmitRequest';

class ServiceRemoval extends React.Component {
	constructor(props) {
		super(props);
		props.dispatch({ type: 'INITIALIZE_STORE' });
		// iniialize the store values 
		props.dispatch({ type: 'INITIALIZE_STORE_SERVICEREMOVAL' });

		//Initialize server api calls
		//All the initialization which need api call, like initializing session, get lookup and check for loggedinUser will done here	
		props.dispatch({ type: 'INITIALIZE_API', projectId: props.projectId, isCopy: props.isCopy, service: "AbandonmentApplicationType" });
	}

	render() {
		const steps = [
			{
				stepName: ServiceAddress,
				stepTitle: 'Service address',
				IsCompleted: false
			},
			{
				stepName: CustomerDetails,
				stepTitle: 'Customer details',
				IsCompleted: false
			},
			{
				stepName: CreateProfile,
				stepTitle: 'Create an online profile',
				IsCompleted: false
			},
			{
				stepName: ProjectSpecifics,
				stepTitle: 'Project specifics',
				IsCompleted: false
			},
			{
				stepName: Schedule,
				stepTitle: 'Schedule',
				IsCompleted: false
			},
			{
				stepName: SubmitRequest,
				stepTitle: 'Submit request',
				IsCompleted: false
			}
		];
		return (
			<Steps steps={steps} />
		);
	}
}

ServiceRemoval.propTypes = {
	dispatch: PropTypes.func,
	projectId: PropTypes.string,
	isCopy: PropTypes.bool
};

const mapStateToProps = (state) => {
	return {
		projectId: state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["projectNo"],
		isCopy: state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["isCopy"]
	};
};

export default connect(mapStateToProps)(ServiceRemoval);